import { render, staticRenderFns } from "./RecommendList.vue?vue&type=template&id=07b2f11a"
import script from "./RecommendList.vue?vue&type=script&lang=js"
export * from "./RecommendList.vue?vue&type=script&lang=js"
import style0 from "./RecommendList.vue?vue&type=style&index=0&id=07b2f11a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports